import { Link } from "react-router-dom";
import { images } from "@/config/images";

export default function LeatherSection() {
  return (
    <section id="leather" className="bg-secondary-50 py-12 md:py-16">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-6 md:mb-8">
          <p className="inline-flex items-center gap-2 text-xs md:text-sm font-bold text-accent-700 bg-accent-100 rounded-full px-4 py-1.5 mb-4">
            <i className="ri-leaf-line"></i>
            猪革・レザー小物
          </p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            猪の革も、無駄にしない
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            命をいただいた猪の革を使い、小物・レザー製品も制作しています。
            猪の革も無駄にせず、小物などに活用しています。
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="rounded-lg overflow-hidden bg-background-50">
            <div className="relative aspect-[16/9]">
              <img
                src="https://storage.helloreaddy.io/project_files/4a24ef4a-ce5d-4268-aaeb-a76be179fd73/6f21473d-a588-400a-9f67-7c43243ba3e2_compressed_S__71688227.webp"
                alt="猪革・レザー小物"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>

        <div className="mt-5 text-center">
          <Link
            to="/leather"
            className="inline-flex items-center gap-2 text-accent-700 text-sm font-bold hover:text-accent-800 transition-colors"
          >
            猪革・レザー紹介ページへ
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}